import React from 'react';
import styles from './ExpressInterestSection.module.scss';

const ExpressInterestSection = () => (
  <section className={styles.expressSection}>
    <div className={styles.content}>
      <h2 className={styles.title}>Express Your Interest</h2>
      <p className={styles.desc}>
        Join us in reshaping the investment property landscape, making property ownership more accessible, transparent, and secure for all.<br />
        Express your interest today and be part of the future!
      </p>
      <div className={styles.emailWrap}>
        <span>Email </span>
        <a href="mailto:info@proprt.io" className={styles.email}>info@proprt.io</a>
        <span> <b>today!</b></span>
      </div>
      <a href="https://proprt.io" className={styles.button} target="_blank" rel="noopener noreferrer">Learn more</a>
    </div>
  </section>
);

export default ExpressInterestSection; 